// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__HXCgR","titleContainer":"Hero_titleContainer__pSK36","cardContainer":"Hero_cardContainer__V0FEG"};